import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/outline'

type Props = {
	features?: { name: string }[]
}

const FeatureList = ({ features }: Props) => (
	<>
		{features?.map((feature, index) => {
			const isMissingFeature = feature.name.charAt(0) === '-'
			const featureName = isMissingFeature ? feature.name.substring(1) : feature.name
			return (
				<div key={index} className="flex items-center gap-2">
					{isMissingFeature ? (
						<XCircleIcon className="text-red-500 flex-none" height={24} width={24} />
					) : (
						<CheckCircleIcon className="text-hitemup-green flex-none" height={24} width={24} />
					)}
					<p>{featureName}</p>
				</div>
			)
		})}
	</>
)

export default FeatureList
